// French (default) — all UI chrome, navigation, forms, legal, admin labels
export const fr = {
  meta: {
    homeTitle: "Bula Telecoms | Fibre, Internet, Satellite et IP Transit en RDC",
    homeDesc: "Bula Telecoms fournit des solutions de connectivité fibre, sans fil, satellite, IP Transit et réseaux d'entreprise en République démocratique du Congo et en Afrique.",
  },
  nav: {
    home: "Accueil", about: "À propos", solutions: "Solutions", sectors: "Secteurs",
    infrastructure: "Infrastructure", impact: "Impact", news: "Actualités", contact: "Contact",
    coverage: "Vérifier la couverture", quote: "Demander un devis", talkExpert: "Parler à un expert",
    careers: "Carrières", partners: "Partenaires", rural: "Connectivité rurale",
    legal: "Mentions légales", privacy: "Confidentialité", cookies: "Cookies",
    menu: "Menu", close: "Fermer",
  },
  hero: {
    eyebrow: "BULA TELECOMS SA — CONNECTIVITÉ & INFRASTRUCTURES NUMÉRIQUES",
    title1: "Connecter la RDC.",
    title2: "Propulser l'Afrique.",
    sub: "Bula Telecoms déploie des solutions de connectivité fibre, sans fil et satellite conçues pour les foyers, les entreprises, les opérateurs et les institutions publiques. Notre ambition est simple : rendre Internet plus fiable, plus accessible et plus utile au développement de l'Afrique.",
    strip: ["Fibre FTTH/FTTB", "Internet fixe sans fil", "Satellite", "IP Transit & DIA", "Solutions entreprises"],
  },
  credibility: {
    items: [
      { title: "3 technologies d'accès", sub: "Fibre, sans fil et satellite" },
      { title: "__CAPACITY__", sub: "__CAPACITY_NOTE__" },
      { title: "Connectivité multi-segments", sub: "Résidentiel, entreprise, opérateur et secteur public" },
      { title: "Vision panafricaine", sub: "La RDC comme point de départ" },
    ],
  },
  mission: {
    heading: "Internet ne devrait pas être un luxe.",
    copy: "Notre mission est de fournir à une part croissante de la population congolaise un accès Internet fiable et abordable. Nous voulons connecter les foyers, renforcer la compétitivité des entreprises, moderniser les institutions et donner aux communautés les moyens de participer pleinement à l'économie numérique.",
    highlight: "Notre réussite repose sur trois piliers : un engagement sans faille, une expertise solide et une approche commerciale innovante, centrée sur les besoins réels du marché.",
    cta: "Découvrir Bula Telecoms",
  },
  solutionsHome: {
    heading: "Une connectivité adaptée à chaque réalité",
    intro: "Aucune technologie unique ne peut répondre à tous les besoins de la RDC et de l'Afrique. Bula Telecoms combine fibre optique, liaisons sans fil, satellite et infrastructures de réseau pour déployer la solution la plus pertinente pour chaque site.",
    cta: "Explorer toutes nos solutions",
  },
  network: {
    heading: "Une architecture pensée pour la résilience",
    copy: "Bula Telecoms s'appuie sur une infrastructure diversifiée intégrant des points de présence, centres de données, routes de fibre optique, backhauls internationaux et interconnexions de qualité opérateur. Cette approche permet d'améliorer la disponibilité, de réduire la latence et de soutenir des déploiements rapides en RDC et dans d'autres marchés africains.",
    highlights: [
      "Architecture multi-route.", "Points de présence et centres de données.",
      "Connectivité internationale.", "Redondance des liens critiques.",
      "Peering, échange de trafic et optimisation des routes.",
      "Solutions adaptées aux exigences de continuité d'activité.",
    ],
    mapLabel: "Illustration de notre architecture réseau",
    cta: "Découvrir notre infrastructure",
  },
  segments: { heading: "Des solutions pour chaque marché" },
  rural: {
    heading: "Aucune communauté ne devrait rester hors réseau.",
    copy: "Bula Telecoms s'engage à étendre l'accès à Internet aux zones rurales et sous-desservies de la République démocratique du Congo et d'Afrique. Notre modèle hybride associe fibre, technologies sans fil et satellite afin de connecter les communautés, écoles, centres de santé, entreprises agricoles, administrations locales et services essentiels.",
    support: "Notre priorité est de connecter les Congolais ordinaires et, plus largement, de permettre aux Africains de participer à l'économie numérique.",
    cta: "Découvrir notre vision pour les zones rurales",
  },
  why: {
    heading: "Pourquoi Bula Telecoms ?",
    items: [
      { title: "Réseau conçu pour la fiabilité", copy: "Une architecture redondante et une combinaison de technologies permettant d'adapter chaque déploiement aux réalités du terrain." },
      { title: "Approche multi-technologie", copy: "Fibre, sans fil et satellite réunis au sein d'un même portefeuille pour couvrir les zones urbaines, périurbaines et éloignées." },
      { title: "Solutions sur mesure", copy: "Chaque réseau est conçu en fonction des objectifs, sites, contraintes opérationnelles et exigences de performance du client." },
      { title: "Service centré sur le client", copy: "Une approche fondée sur l'écoute, la réactivité, la transparence et l'accompagnement à long terme." },
      { title: "Expertise locale, ambition continentale", copy: "Une connaissance des environnements africains combinée à des standards techniques et opérationnels internationaux." },
    ],
  },
  ecosystem: { label: "Écosystème réseau et infrastructures" },
  finalCta: {
    heading: "Construisons la connexion dont votre projet a besoin.",
    copy: "Qu'il s'agisse de connecter un foyer, une entreprise, plusieurs agences, une institution ou un réseau opérateur, notre équipe vous aidera à identifier l'architecture la plus adaptée.",
  },
  footer: {
    mission: "Une connectivité fiable, abordable et résiliente pour les particuliers, les entreprises, les opérateurs et les institutions publiques.",
    solutions: "Solutions", sectors: "Secteurs", company: "Entreprise", contact: "Contact",
    newsletter: "Restez informé", newsletterPlaceholder: "Votre adresse e-mail",
    newsletterBtn: "S'inscrire", legal: "Légal",
    rights: "© {year} Bula Telecoms SA. Tous droits réservés.",
    tagline: "Conçu en Afrique pour connecter l'Afrique.",
  },
  forms: {
    required: "Ce champ est requis",
    invalidEmail: "Adresse e-mail invalide",
    consentRequired: "Veuillez accepter la politique de confidentialité",
    consentLabel: "J'accepte que mes données soient traitées conformément à la politique de confidentialité.",
    securityCheck: "Vérification de sécurité",
    sending: "Envoi en cours…", submit: "Envoyer",
    success: "Votre demande a bien été reçue.",
    error: "Une erreur est survenue. Veuillez réessayer.",
    privacyNote: "Les informations collectées sont destinées à Bula Telecoms pour le traitement de votre demande. Consultez notre politique de confidentialité.",
  },
  coverage: {
    title: "Vérifier la couverture",
    subtitle: "Indiquez-nous votre adresse : notre équipe analysera la disponibilité et les options techniques pour votre site.",
    successMsg: "Votre demande de vérification a bien été reçue. Notre équipe analysera la disponibilité et les options techniques pour votre adresse.",
    fields: {
      customerType: "Type de client", fullName: "Nom complet", company: "Entreprise ou organisation",
      phone: "Téléphone", email: "E-mail", province: "Province", city: "Ville",
      commune: "Commune ou quartier", address: "Adresse complète d'installation",
      mapPin: "Coordonnées ou point carte (optionnel)", buildingType: "Type de bâtiment",
      usersOrSites: "Nombre d'utilisateurs ou de sites", service: "Service souhaité",
      capacity: "Capacité souhaitée", contactMethod: "Mode de contact préféré",
      details: "Précisions supplémentaires",
    },
    customerTypes: ["Particulier", "Résidence ou immeuble", "Entreprise", "Opérateur ou FAI", "Gouvernement ou institution publique", "Promoteur immobilier", "Revendeur", "Autre"],
    buildingTypes: ["Maison individuelle", "Appartement", "Immeuble collectif", "Bureau", "Site industriel", "Campus", "Autre"],
    contactMethods: ["Téléphone", "E-mail", "WhatsApp"],
    submit: "Envoyer ma demande",
  },
  quote: {
    title: "Demander un devis",
    subtitle: "Un parcours guidé en 5 étapes pour nous aider à concevoir la solution la plus adaptée à votre projet.",
    steps: ["Profil client", "Service souhaité", "Site & couverture", "Exigences techniques", "Contact & envoi"],
    step1: { customerType: "Type de client", company: "Entreprise ou organisation", sector: "Secteur d'activité" },
    step2: { service: "Service principal", details: "Précisez votre besoin" },
    step3: { province: "Province", city: "Ville", address: "Adresse du site", sites: "Nombre de sites" },
    step4: {
      bandwidth: "Bande passante requise", connectionType: "Type de connexion",
      dedicated: "Dédiée", shared: "Mutualisée", redundancy: "Besoin de redondance",
      sla: "Exigence de SLA", publicIp: "Besoin d'IP publiques",
      existingProvider: "Fournisseur actuel", targetDate: "Date cible de déploiement",
      description: "Description du projet", attachment: "Pièce jointe (optionnel)",
    },
    step5: { fullName: "Nom complet", role: "Fonction", email: "E-mail", phone: "Téléphone", contactMethod: "Mode de contact préféré" },
    conditional: {
      fibre: "Longueur approximative ou bâtiments à desservir",
      wireless: "Visibilité dégagée entre les sites ?",
      satellite: "Zone d'intervention et contraintes d'accès",
      iptransit: "Capacité actuelle et ports souhaités",
      government: "Institution, périmètre du projet et parties prenantes",
      civil: "Type d'ouvrage (tranchées, aérien, chambres…) et linéaire estimé",
    },
    back: "Retour", next: "Continuer", submit: "Envoyer la demande de devis",
    successMsg: "Votre demande de devis a bien été reçue. Notre équipe analysera vos besoins et reviendra vers vous.",
  },
  contact: {
    title: "Contact",
    subtitle: "Une question, un projet, un partenariat ? Notre équipe vous répond.",
    departments: {
      general: "Demandes générales", sales: "Ventes", enterprise: "Entreprises & wholesale",
      government: "Projets gouvernementaux", partnerships: "Partenariats", careers: "Carrières", media: "Médias & presse",
    },
    fields: { department: "Service destinataire", name: "Nom complet", email: "E-mail", phone: "Téléphone", subject: "Objet", message: "Message" },
    submit: "Envoyer le message",
    successMsg: "Votre message a bien été reçu. Notre équipe vous répondra dans les meilleurs délais.",
    hq: "Siège — Kinshasa", office: "Bureau — Le Cap", hours: "Horaires d'ouverture",
    emergency: "Support réseau",
  },
  careers: {
    title: "Carrières",
    heading: "Rejoignez une équipe qui construit les infrastructures numériques de demain.",
    intro: "Chez Bula Telecoms, nous concevons et déployons les réseaux qui connectent la RDC et l'Afrique. Rejoindre nos équipes, c'est participer concrètement à la transformation numérique du continent.",
    openPositions: "Postes ouverts",
    noPositions: "Aucun poste n'est publié pour le moment. Vous pouvez néanmoins nous adresser une candidature spontanée ci-dessous.",
    apply: "Postuler",
    spontaneous: "Candidature spontanée",
    fields: { name: "Nom complet", email: "E-mail", phone: "Téléphone", position: "Poste visé", location: "Localisation", linkedin: "Profil LinkedIn", cv: "CV (PDF)", cover: "Message de motivation" },
    submit: "Envoyer ma candidature",
    successMsg: "Votre candidature a bien été reçue. Notre équipe l'examinera avec attention.",
  },
  news: { title: "Actualités & analyses", readMore: "Lire l'article", back: "Retour aux actualités", empty: "Les actualités seront publiées prochainement." },
  about: {
    heading: "Une entreprise africaine bâtie pour connecter l'avenir",
    missionTitle: "Notre mission",
    mission: "Fournir une connectivité fiable, abordable et utile au développement, afin qu'Internet devienne une infrastructure essentielle accessible au plus grand nombre.",
    visionTitle: "Notre vision",
    vision: "Accroître durablement la pénétration de l'accès à Internet en République démocratique du Congo, puis étendre cette transformation à l'échelle du continent africain.",
    vision2: "À travers la connectivité, nous voulons renforcer l'autonomie des jeunes, des familles, des entrepreneurs, des entreprises et des institutions.",
    valuesTitle: "Nos valeurs",
    values: ["Engagement", "Excellence", "Innovation", "Accessibilité", "Intégrité", "Orientation client", "Impact durable"],
    timelineTitle: "Notre parcours",
    timeline: [
      { year: "2017", title: "Afrique du Sud", text: "Création de Bula Telecoms." },
      { year: "2019", title: "République démocratique du Congo", text: "Établissement et développement des activités en RDC." },
      { year: "Aujourd'hui", title: "Expansion africaine", text: "Développement d'un portefeuille multi-technologie et d'une stratégie d'expansion africaine." },
    ],
    corporateTitle: "Informations institutionnelles",
    corporate: [
      "Profil d'entreprise téléchargeable",
      "Gouvernance et conformité : Bula Telecoms SA est immatriculée en République démocratique du Congo et applique des pratiques de gouvernance, de conformité réglementaire et de gestion responsable des données.",
      "Stratégie géographique : la RDC comme marché d'ancrage, puis une expansion progressive vers d'autres marchés africains.",
    ],
    downloadProfile: "Télécharger le profil d'entreprise",
    partnershipCta: "Proposer un partenariat",
    mediaContact: "Contact médias & presse",
  },
  infrastructure: {
    heading: "Une infrastructure conçue pour la performance et la continuité",
    intro: "Notre réseau combine points de présence, interconnexion de centres de données, backhaul de qualité opérateur, routes internationales, anneaux fibre, accès sans fil et redondance satellite.",
    items: [
      { title: "Points de présence", text: "Des points de présence stratégiques pour rapprocher le réseau des utilisateurs." },
      { title: "Interconnexion de centres de données", text: "Hébergement et interconnexion au sein d'environnements de classe opérateur." },
      { title: "Backhaul international", text: "Routes internationales diversifiées pour sécuriser la capacité et la disponibilité." },
      { title: "Anneaux fibre optique", text: "Architectures en anneau pour la résilience des routes métropolitaines." },
      { title: "Accès sans fil", text: "Liaisons P2P et P2MP pour une distribution rapide et flexible." },
      { title: "Redondance satellite", text: "Secours satellite pour les sites critiques et les zones isolées." },
      { title: "Capacité de gros", text: "Capacité wholesale évolutive pour opérateurs et FAI." },
      { title: "Peering & échange de trafic", text: "Optimisation des routes et échange de trafic pour réduire la latence." },
      { title: "Supervision du réseau", text: "Surveillance continue pour anticiper les incidents et garantir la continuité de service." },
    ],
    mapLabel: "Illustration de notre architecture réseau",
  },
  ruralPage: {
    heading: "Connecter les territoires que les réseaux traditionnels ne peuvent atteindre seuls",
    p1: "La fracture numérique ne se limite pas à l'absence de signal. Elle affecte l'éducation, la santé, l'entrepreneuriat, l'agriculture, les services publics et la participation économique.",
    p2: "Notre modèle de connectivité rurale combine les technologies disponibles en fonction du terrain : fibre pour les axes structurants, accès sans fil pour la distribution locale et satellite pour les zones isolées ou les déploiements rapides.",
    impactTitle: "Domaines d'impact",
    impacts: ["Éducation", "Santé", "Agriculture", "Administration publique", "Inclusion financière", "Entrepreneuriat", "Sécurité", "Communication communautaire"],
    cta: "Proposer un projet de connectivité rurale",
  },
  partnersPage: {
    heading: "Partenaires & écosystème",
    intro: "Bula Telecoms collabore avec un écosystème d'organisations d'infrastructure, de connectivité et de technologie. Chaque logo affiché l'est avec l'accord de l'organisation concernée.",
    label: "Écosystème réseau et infrastructures",
    become: "Devenir partenaire",
    note: "Les organisations présentées ne sont ni des investisseurs ni des clients, sauf mention explicite.",
  },
  solutionCommon: {
    outcome: "Résultat pour votre organisation", overview: "Aperçu technique", useCases: "Cas d'usage",
    segments: "Segments concernés", benefits: "Avantages clés", process: "Processus de déploiement",
    faq: "Questions fréquentes", cta: "Demander un devis", related: "Solutions associées",
    processSteps: ["Échange et qualification du besoin", "Étude de faisabilité technique", "Conception de l'architecture", "Déploiement et mise en service", "Supervision et accompagnement"],
    availability: "Disponibilité soumise à étude de faisabilité, couverture, réglementation et conditions contractuelles.",
  },
  legalPages: {
    legal: {
      title: "Mentions légales",
      sections: [
        { h: "Éditeur du site", p: "Bula Telecoms SA\nImmeuble Quantum, 2ème étage, Appartement A\n81/77 Boulevard du 30 Juin, Kinshasa–Gombe\nRépublique démocratique du Congo\nTél. : +243 904 444 213\nE-mail : info@bulatelecoms.com" },
        { h: "Immatriculation", p: "RCCM : RCCM/19-B-00673\nID. NAT. : O1-730-N45580L" },
        { h: "Bureau secondaire", p: "No. 2 Ixia Street, Unit 5, Milpark, Milnerton 7441, Le Cap, Afrique du Sud\nTél. : +27 87 820 5053" },
        { h: "Propriété intellectuelle", p: "L'ensemble des contenus du site (textes, visuels, logo) est la propriété de Bula Telecoms SA, sauf mention contraire. Toute reproduction sans autorisation écrite est interdite." },
      ],
    },
    privacy: {
      title: "Politique de confidentialité",
      sections: [
        { h: "Données collectées", p: "Nous collectons les données que vous nous transmettez via nos formulaires (identité, coordonnées, adresse d'installation, besoins techniques) afin de traiter vos demandes de couverture, devis, contact, candidature ou inscription à notre lettre d'information." },
        { h: "Finalités et base légale", p: "Ces traitements reposent sur votre consentement et sur l'exécution de mesures précontractuelles. Ils servent à répondre à vos demandes, à gérer la relation commerciale et, avec votre accord, à vous adresser des communications." },
        { h: "Conservation", p: "Les données sont conservées pendant la durée nécessaire au traitement de votre demande, puis selon les durées configurées par nos soins (les leads et messages sont conservés pour une durée limitée, paramétrable dans notre espace d'administration)." },
        { h: "Vos droits", p: "Vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour les exercer, écrivez à info@bulatelecoms.com." },
        { h: "Sécurité", p: "Nous appliquons des mesures techniques et organisationnelles adaptées : accès restreint, journalisation, protection anti-spam et validation côté serveur." },
      ],
    },
    cookies: {
      title: "Politique relative aux cookies",
      sections: [
        { h: "Cookies essentiels", p: "Le site utilise uniquement des cookies et stockages techniques nécessaires à son fonctionnement (préférence de langue, session d'administration, préférences de consentement)." },
        { h: "Cookies non essentiels", p: "Aucun cookie d'analyse ou marketing n'est déposé sans votre consentement préalable. Vous pouvez modifier vos préférences à tout moment." },
        { h: "Gérer vos préférences", p: "Utilisez le panneau de préférences accessible via le bouton « Cookies » en pied de page." },
      ],
    },
  },
  cookiesBanner: {
    title: "Respect de votre vie privée",
    text: "Nous utilisons uniquement des cookies essentiels au fonctionnement du site. Les cookies non essentiels ne sont activés qu'avec votre accord.",
    accept: "Tout accepter", reject: "Refuser", customize: "Personnaliser", save: "Enregistrer",
    essential: "Essentiels (toujours actifs)", analytics: "Mesure d'audience", marketing: "Marketing",
    manage: "Cookies",
  },
  breadcrumbHome: "Accueil",
  notFound: { title: "Page introuvable", text: "La page demandée n'existe pas ou a été déplacée.", cta: "Retour à l'accueil" },
  admin: {
    login: "Connexion à l'administration", email: "E-mail", password: "Mot de passe", signIn: "Se connecter",
    dashboard: "Tableau de bord", leads: "Leads", coverage: "Vérifications de couverture", quotes: "Demandes de devis",
    messages: "Messages", applications: "Candidatures", newsletter: "Newsletter",
    content: "Contenu", posts: "Actualités", jobs: "Offres d'emploi", partners: "Partenaires", team: "Équipe",
    faqs: "FAQ", documents: "Documents", locations: "Bureaux", settings: "Paramètres", users: "Utilisateurs",
    audit: "Journal d'audit", outbox: "Boîte d'envoi", logout: "Déconnexion",
    statuses: { nouveau: "Nouveau", a_contacter: "À contacter", contacte: "Contacté", qualifie: "Qualifié", etude_technique: "Étude technique", devis_envoye: "Devis envoyé", gagne: "Gagné", perdu: "Perdu", archive: "Archivé" },
    exportCsv: "Exporter CSV", search: "Rechercher…", filterStatus: "Statut", filterSource: "Source",
    assign: "Assigner à", addNote: "Ajouter une note", notes: "Notes internes", history: "Historique",
    save: "Enregistrer", cancel: "Annuler", create: "Créer", edit: "Modifier", delete: "Supprimer",
    published: "Publié", draft: "Brouillon", confirmDelete: "Confirmer la suppression ?",
    smtpTitle: "Configuration SMTP (e-mails sortants)", testEmail: "E-mail de notification interne",
    noData: "Aucune donnée.", loginFailed: "Identifiants invalides.",
    roles: { super_admin: "Super administrateur", editor: "Éditeur de contenu", sales: "Commercial", analyst: "Analyste (lecture seule)" },
    totalLeads: "Leads totaux", newLeads: "Nouveaux leads", thisMonth: "Ce mois-ci", bySource: "Par source",
  },
};
